import React from 'react';
import '../../styles/CaseStudyOne/CaseStudiesTesting.css';

const CaseStudiesTesting = () => {
  return (
    <section className="testing-section">
      <div className="testing-container">
        <h2 className="testing-section-title">Testing and Optimization</h2>
        <p className="testing-section-description">
          Google Performance Max outperforms traditional search by using machine learning to optimize campaigns across all
          Google channels, including Search, Display, and YouTube. Unlike keyword-focused search, PMAX leverages audience
          signals and real-time data to boost reach, conversions, and efficiency. For Bullfrog, not using PMAX effectively was
          limiting potential volume and hurting overall efficiency, highlighting the need for a more data-driven, automated
          approach.
        </p>

        {/* Row 1 */}
        <div className="testing-row">
          <div className="testing-content">
            <div className="testing-checkmark-icon"></div>
            <div>
              <h4 className="testing-title">Integration of ASKAI to Track Booked Appointments</h4>
              <p className="testing-text">
                Bullfrog Pool Tile Cleaning implemented Call Tracking Metrics’ ASKAI feature, which uses AI to transcribe and analyze calls.
               This feature identifies which inbound calls result in a booked service, eliminating guesswork and improving conversion tracking.
              </p>
            </div>
          </div>
          <div className="testing-image-placeholder">
          <img
              src={require("../../assets/bot.png")}
              alt="Bot"
              className="testing-section-image"
            />
          </div>
        </div>

        {/* Row 2 */}
        <div className="testing-row reverse">
          <div className="testing-content">
            <div className="testing-checkmark-icon"></div>
            <div>
              <h4 className="testing-title">Optimized Google PMAX Campaigns</h4>
              <p className="testing-text">
                With ASKAI providing clear booked call data, Bullfrog Pool Tile Cleaning:
              </p>
              <ul className="testing-text">
                <li>Enabled PMAX campaigns while only counting booked calls as conversions</li>
                <li>Reduced the impact of spam calls and form submissions</li>
              </ul>
            </div>
          </div>
          <div className="testing-image-placeholder">
          <img
              src={require("../../assets/stock-arrows.png")}
              alt="Bot"
              className="testing-section-image"
            />
          </div>
        </div>

        {/* Row 3 */}
        <div className="testing-row">
          <div className="testing-content">
            <div className="testing-checkmark-icon"></div>
            <div>
              <h4 className="testing-title">Weighted Booked Calls in Search Campaigns</h4>
              <p className="testing-text">
              The team adjusted their Google Search campaigns to weight booked calls more heavily as a conversion goal. This ensured their budget focused on leads most likely to convert.
              </p>
            </div>
          </div>
          <div className="testing-image-placeholder">
          <img
              src={require("../../assets/cellphone.png")}
              alt="Bot"
              className="testing-section-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesTesting;